<template>
  <div class="financementsDetailSection">
    <div
      class="financementsDetailWrapper"
      v-for="(elem, index) in detailModulesList"
      :key="index"
    >
      <div class="sectionHeading">
        <span class="sectionTitle">{{ `Module du ${elem[0]?.dateDebut} au ${elem[0]?.dateFin}` }}</span>
        <span class="sectionSubtitle">{{ elem[0]?.organisme }} / {{ elem[0]?.intitule }}</span>
      </div>
      <div class="financementsDetailDesktopWrapper">
        <div class="cardLayoutWrapper cardLayoutWrapper--header">
          <div class="elem elem--span-1"></div>
          <div class="elem elem--span-3">
            <span>Nature</span>
          </div>
          <div class="elem elem--span-3" style="justify-content: end;">
            <span>Demandé (HT)</span>
          </div>
          <div class="elem elem--span-4">
            <span>Intitulé</span>
          </div>
          <div class="elem elem--span-6">
            <span>Bénéficiaire</span>
          </div>
          <div class="elem elem--span-3 elem--right" style="justify-content: end;">
            <span>Accordé (HT)</span>
          </div>
          <!-- <div class="elem elem--span-3 elem--right" style="justify-content: end;">
            <span>Montant facturé (HT)</span>
          </div> -->
          <div class="elem elem--span-3 elem--right" style="justify-content: end;">
            <span>Payé (HT)</span>
          </div>
          <div class="elem elem--span-3 elem--right" style="justify-content: end;">
            <span>Solde (HT)</span>
          </div>
          <div class="elem elem--span-9"></div>
        </div>
        <div
          class="gridElemWrapper"
          v-for="(item, index) in elem"
          :key="index"
        >
          <div v-if="item.financementDetails.length! > 0">
            <div class="cardLayoutWrapper">
              <div class="elem elem--span-1"></div>
              <div class="elem elem--span-3 elem--bold">
                <span>{{ getLovIntitule(store.lov!.SousNatureFrais, item.sousNatureFrais) }}</span>
              </div>
              <div class="elem elem--span-3 elem--bold elem--right">
                <span>{{ financementDemandeFormatter(item) }}</span>
              </div>
              <div class="elem elem--span-4 elem--bold"></div>
              <div class="elem elem--span-6 elem--bold">
                <span>{{ financementRecap(item).beneficiaireRecap }}</span>
              </div>
              <div class="elem elem--span-3 elem--bold elem--right">
                <span>{{ financementRecap(item).accordeRecap + ' €'}}</span>
              </div>
              <!-- <div class="elem elem--span-4 elem--bold elem--right">
                <span>{{ financementRecap(item).factureRecap + ' €'}}</span>
              </div> -->
              <div class="elem elem--span-3 elem--bold elem--right">
                <span>{{ financementRecap(item).payeRecap + ' €'}}</span>
              </div>
              <div class="elem elem--span-3 elem--bold elem--right">
                <span>{{ financementRecap(item).soldeRecap + ' €'}}</span>
              </div>
              <div class="elem elem--span-7"></div>
              <div class="elem elem--span-2">
                <BasicButton
                  label="Détails"
                  iconRight
                  size="small"
                  :iconName="drawerId === item.idModule + item.montantDemande ? 'arrow-up' : 'arrow-down'"
                  @click="toggleDrawer(item.idModule + item.montantDemande)"
                />
              </div>
            </div>
            <div v-if="drawerId === item.idModule + item.montantDemande">
              <div
                class="gridElemWrapper"
                v-for="(element, index) in item.financementDetails"
                :key="index"
              >
                <div class="cardLayoutWrapper cardLayoutWrapper--drawer">
                  <div class="elem elem--span-1"></div>
                  <div class="elem elem--span-6"></div>
                  <div class="elem elem--span-4">
                    <span>{{ getLovIntitule(store.lov!.TypeFinancement, element.typeFinancement) }}</span>
                  </div>
                  <div class="elem elem--span-6 elem--column">
                    <div class="drawer-picto-line">
                      <BasicIcon :name="element.typeEntrepriseEtablissement === 'Tiers' ? 'building' : 'bank'" />
                      <span>{{ element.denominationEtablissement }}</span>
                    </div>
                    <div class="drawer-picto-line">
                      <BasicIcon name="profile" />
                      <div v-if="element?.prenomStagiaire && element?.nomStagiaire">
                        {{ formatFirstName(element.prenomStagiaire) }}
                        {{ element.nomStagiaire.toLocaleUpperCase('fr-FR') }}
                      </div>
                    </div>
                  </div>
                  <div class="elem elem--span-3 elem--right">
                    <span>{{ formatNumber(element.montantEngage, { decimal: 2, separateur: true }) + ' €' }}</span>
                  </div>
                  <div class="elem elem--span-3 elem--right">
                    <span>{{ formatNumber(element.montantRegle, { decimal: 2, separateur: true }) + ' €' }}</span>
                  </div>
                  <div class="elem elem--span-3 elem--right">
                    <span>{{ formatNumber(element.montantSolde, { decimal: 2, separateur: true }) + ' €' }}</span>
                  </div>
                  <div class="elem elem--span-3"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.financementDetails?.length! <= 0">
            <div class="gridElemWrapper">
              <div class="cardLayoutWrapper">
                <div class="elem elem--span-1"></div>
                <div class="elem elem--span-3">
                  <span>{{ getLovIntitule(store.lov!.SousNatureFrais, item.sousNatureFrais) }}</span>
                </div>
                <div class="elem elem--span-3 elem--right">
                  <span>{{ financementDemandeFormatter(item) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="financementsDetailMobileWrapper"
        v-for="(item, index) in elem"
        :key="index"
      >
        <div class="rowMobile">
          <div class="rowLeft rowLeft--recap">
            <span>Nature</span>
          </div>
          <div class="rowRight rowRight--recap">
            <span>{{ getLovIntitule(store.lov!.SousNatureFrais, item.sousNatureFrais) }}</span>
          </div>
        </div>
        <div class="rowMobile">
          <div class="rowLeft rowLeft--recap">
            <span>Demandé</span>
          </div>
          <div class="rowRight rowRight--recap">
            <span>{{ financementDemandeFormatter(item) }}</span>
          </div>
        </div>
        <div class="rowMobile">
          <div class="rowLeft rowLeft--recap">
            <span>Bénéficiaire</span>
          </div>
          <div class="rowRight rowRight--recap">
            <span>{{ financementRecap(item).beneficiaireRecap }}</span>
          </div>
        </div>
        <div class="rowMobile">
          <div class="rowLeft rowLeft--recap">
            <span>Accordé (HT)</span>
          </div>
          <div class="rowRight rowRight--recap">
            <span>{{ financementRecap(item).accordeRecap }}</span>
          </div>
        </div>
        <!-- <div class="rowMobile">
          <div class="rowLeft rowLeft--recap">
            <span>Montant facturé (HT)</span>
          </div>
          <div class="rowRight rowRight--recap">
            <span>{{ financementRecap(item).factureRecap }}</span>
          </div>
        </div> -->
        <div class="rowMobile">
          <div class="rowLeft rowLeft--recap">
            <span>Payé (HT)</span>
          </div>
          <div class="rowRight rowRight--recap">
            <span>{{ financementRecap(item).payeRecap }}</span>
          </div>
        </div>
        <div class="rowMobile">
          <div class="rowLeft rowLeft--recap">
            <span>Solde (HT)</span>
          </div>
          <div class="rowRight rowRight--recap">
            <span>{{ financementRecap(item).soldeRecap }}</span>
          </div>
        </div>
        <div
          class="rowMobile"
          v-if="item.financementDetails.length"
        >
          <div class="rowLeft rowLeft--recap">
            <BasicButton
              label="Détails"
              iconRight
              size="small"
              :iconName="drawerId === item.idModule + item.montantDemande ? 'arrow-up' : 'arrow-down'"
              @click="toggleDrawer(item.idModule + item.montantDemande)"
            />
          </div>
          <div class="rowRight rowRight--recap"></div>
        </div>
        <div
          class="cardDesktopDetailList"
          v-if="drawerId === item.idModule + item.montantDemande"
        >
          <div
            class="cardMobile"
            v-for="(element, index) in item.financementDetails"
            :key="index"
          >
            <div class="rowMobile">
              <div class="rowLeft rowLeft--detail">
                <span>Intitulé</span>
              </div>
              <div class="rowRight rowRight--detail">
                <span>{{ getLovIntitule(store.lov!.TypeFinancement, element.typeFinancement) }}</span>
              </div>
            </div>
            <div class="rowMobile">
              <div class="rowLeft rowLeft--detail">
                <span>Bénéficiaire</span>
              </div>
              <div class="rowRight rowRight--detail">
                <div v-if="element?.prenomStagiaire && element?.nomStagiaire">
                  {{ formatFirstName(element.prenomStagiaire) }} {{ element.nomStagiaire.toLocaleUpperCase('fr-FR') }}
                </div>
              </div>
            </div>
            <div class="rowMobile">
              <div class="rowLeft rowLeft--detail">
                <span>Accordé (HT)</span>
              </div>
              <div class="rowRight rowRight--detail">
                <span>{{ formatNumber(element.montantEngage, { decimal: 2, separateur: true }) }}</span>
              </div>
            </div>
            <div class="rowMobile">
              <div class="rowLeft rowLeft--detail">
                <span>Payé (HT)</span>
              </div>
              <div class="rowRight rowRight--detail">
                <span>{{ formatNumber(element.montantRegle, { decimal: 2, separateur: true }) }}</span>
              </div>
            </div>
            <div class="rowMobile">
              <div class="rowLeft rowLeft--detail">
                <span>Solde (HT)</span>
              </div>
              <div class="rowRight rowRight--detail">
                <span>{{ formatNumber(element.montantSolde, { decimal: 2, separateur: true }) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import type { ModuleFinancementDTO } from '@/features/api/extranet/dto/Dossier/Synthese/FinancementDTO'
  import { formatNumber, formatFirstName } from '@/features/shared/tools'
  import { getLovIntitule } from '../../../shared/tools'
  import { useDossierStore } from '../useDossierStore'

  defineProps<{
    detailModulesList: Array<Array<ModuleFinancementDTO>>
  }>()

  const store = useDossierStore()
  const drawerId = ref()
  const toggleDrawer = (id: number) => {
    if (drawerId.value === id) {
      drawerId.value = null
    } else {
      drawerId.value = id
    }
  }

  const financementDemandeFormatter = (financement: ModuleFinancementDTO) => {
    switch (financement.typeMontantDemande) {
      case 'Monetaire':
        return formatNumber(financement.montantDemande, { decimal: 2, separateur: true }) + ' €'
      case 'DureeHeure':
        return financement.montantDemande + ' heures'
      case 'DureeMois':
        return financement.montantDemande + ' mois'
      case 'Quantite':
        return financement.montantDemande + ' (quantité)'
    }
  }

  const financementRecap = (financement: ModuleFinancementDTO) => {
    const recap = {
      beneficiaireCount: 0,
      beneficiaireRecap: '',
      accordeRecap: '',
      factureRecap: '',
      payeRecap: '',
      soldeRecap: '',
    }
    let accorde = 0
    let facture = 0
    let paye = 0
    let solde = 0

    financement.financementDetails.forEach((financement: any) => {
      if (financement.denominationEtablissement?.length) {
        recap.beneficiaireCount++
      }
      if (financement.denominationEtablissement?.length && !recap.beneficiaireRecap) {
        recap.beneficiaireRecap = financement.denominationEtablissement
      }
      accorde += financement.montantEngage
      facture += financement.montantFacture
      paye += financement.montantRegle
      solde += financement.montantSolde
    })

    if (recap.beneficiaireCount > 1) {
      recap.beneficiaireRecap = recap.beneficiaireRecap + ' + ' + (recap.beneficiaireCount - 1)
    }

    recap.accordeRecap = formatNumber(accorde, { decimal: 2, separateur: true })
    recap.factureRecap = formatNumber(facture, { decimal: 2, separateur: true })
    recap.payeRecap = formatNumber(paye, { decimal: 2, separateur: true })
    recap.soldeRecap = formatNumber(solde, { decimal: 2, separateur: true })

    return recap
  }
</script>

<style scoped lang="less">
  @import '../../index.less';
</style>
